module.exports = __webpack_public_path__ + "static/media/left-arrow.a0c7ff72.png";